import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./IdwalFooter.module.css";
import { IdwalFooterProps } from "../types/IdwalFooterProps";

export const IdwalFooter = ({
    termsAndConditionsLink,
    showCookieConsent,
    onClickCookiePolicy,
    backgroundColor
}: IdwalFooterProps) => {
    const { t } = useTranslation("common");
    const currentYear = new Date().getFullYear();

    return (
        <footer
            style={{ backgroundColor: `${backgroundColor ?? "#ffffff"}` }}
            className={`${styles.Footer} relative w-full py-6`}
            data-testid="footer"
        >
            <div className="max-width-wrapper h-full flex flex-column justify-content-center md:align-items-center md:justify-content-start md:flex-row gap-3 text-sm">
                <div className="flex-wrap" data-testid="copyright">{`${t(
                    "footer.copyright",
                    {
                        currentYear: currentYear
                    }
                )}`}</div>
                <div className="md:flex hidden">|</div>
                <div>
                    <a
                        href="https://www.idwalmarine.com/iso"
                        target="_blank"
                        data-testid="iso"
                    >{`${t("footer.iso")}`}</a>
                </div>
                <div className="md:flex hidden">|</div>
                <div className="flex gap-3" data-testid="terms">
                    <a href={termsAndConditionsLink} target="_blank">
                        {`${t("footer.terms")}`}
                    </a>
                    <div>|</div>
                    <a
                        href="https://www.idwalmarine.com/privacy-policy"
                        target="_blank"
                        data-testid="privacy-policy"
                    >
                        {`${t("footer.privacy")}`}
                    </a>
                </div>
                {showCookieConsent && (
                    <>
                        <div>|</div>
                        <div className="flex gap-3">
                            <a
                                onClick={onClickCookiePolicy}
                                target="_blank"
                                style={{ textDecoration: "underline" }}
                                data-testid="cookie-policy"
                            >
                                {`${t("footer.cookie")}`}
                            </a>
                        </div>
                    </>
                )}
            </div>
        </footer>
    );
};
